import { memo } from 'react';

export const MainSideNavSeparator = memo(() => {
  return (
    <div aria-hidden className="w-full shrink-0 py-1.5" data-testid="MAIN_SIDE_NAV_SEPARATOR">
      <div className="ml-4 h-px w-7 bg-gray-4 group-has-[[data-state=open]]/main-side-nav:mx-4 group-has-[[data-state=open]]/main-side-nav:w-auto group-data-[hover-expand]/main-side-nav:mx-4 group-data-[pinned]/main-side-nav:mx-4 group-data-[hover-expand]/main-side-nav:w-auto group-data-[pinned]/main-side-nav:w-auto" />
    </div>
  );
});

MainSideNavSeparator.displayName = 'MainSideNavSeparator';
